export const MOSTRAR_DATOSSENSORES = 'MOSTRAR_DATOSSENSORES';
export const TOKEN_DATOSSENSORES = 'TOKEN_DATOSSENSORES';
export const PACT_DATOSENSOR = 'PACT_DATOSENSOR';
export const SIMULATE_DATOSENSOR = 'SIMULATE_DATOSENSOR';
export const SIMULATE_DATOSSENSORES = 'SIMULATE_DATOSSENSORES';

export const MOSTRAR_CONTRACT = 'MOSTRAR_CONTRACT';
export const AGREGAR_CONTRACT = 'AGREGAR_CONTRACT';
export const MODIFICAR_CONTRACT = 'MODIFICAR_CONTRACT';
export const ELIMINAR_CONTRACT = 'ELIMINAR_CONTRACT';

export const VALIDAR_FORMULARIO = 'VALIDAR_FORMULARIO';
export const MOSTRAR_ERROR = 'MOSTRAR_ERROR';

//-----
// Auth
//-----
export const AUTH_SIGN_IN = 'AUTH_SIGN_IN';
export const AUTH_SIGN_OUT = 'AUTH_SIGN_OUT';
export const AUTH_CONNECTING = 'AUTH_CONNECTING';
export const AUTH_CONNECTED = 'AUTH_CONNECTED';
export const AUTH_DISCONNECTED = 'AUTH_DISCONNECTED';
export const AUTH_PROFILE_USER = 'AUTH_PROFILE_USER';

export const LOGIN = 'LOGIN';
export const HANDLE_LOGIN = 'HANDLE_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_SIGNING_IN = 'USER_SIGNING_IN';
export const USER_SIGNED_IN = 'USER_SIGNED_IN';

//------------------------------
//Smart Contract Logistic Config
//------------------------------
export const FETCH_PACT_LOGISTIC_CONFIG = 'FETCH_PACT_LOGISTIC_CONFIG';
export const FETCH_PACT_REQUEST_LOGISTIC_CONFIG = 'FETCH_PACT_REQUEST_LOGISTIC_CONFIG';
export const FETCH_PACT_SUCCEEDED_LOGISTIC_CONFIG = 'FETCH_PACT_SUCCEEDED_LOGISTIC_CONFIG';
export const FETCH_PACT_FAILED_LOGISTIC_CONFIG = 'FETCH_PACT_FAILED_LOGISTIC_CONFIG';

export const FETCH_PACT_LOGISTIC_CONFIG_CONTRACTID = 'FETCH_PACT_LOGISTIC_CONFIG_CONTRACTID';
export const FETCH_PACT_REQUEST_LOGISTIC_CONFIG_CONTRACTID = 'FETCH_PACT_REQUEST_LOGISTIC_CONFIG_CONTRACTID';
export const FETCH_PACT_SUCCEEDED_LOGISTIC_CONFIG_CONTRACTID = 'FETCH_PACT_SUCCEEDED_LOGISTIC_CONFIG_CONTRACTID';
export const FETCH_PACT_FAILED_LOGISTIC_CONFIG_CONTRACTID = 'FETCH_PACT_FAILED_LOGISTIC_CONFIG_CONTRACTID';

export const FETCH_DELETED_PACT_LOGISTIC_CONFIG = 'FETCH_DELETED_PACT_LOGISTIC_CONFIG';
export const FETCH_DELETED_PACT_REQUEST_LOGISTIC_CONFIG = 'FETCH_DELETED_PACT_REQUEST_LOGISTIC_CONFIG';
export const FETCH_DELETED_PACT_SUCCEEDED_LOGISTIC_CONFIG = 'FETCH_DELETED_PACT_SUCCEEDED_LOGISTIC_CONFIG';
export const FETCH_DELETED_PACT_FAILED_LOGISTIC_CONFIG = 'FETCH_PACT_DELETED_FAILED_LOGISTIC_CONFIG';

export const SAVE_NEW_PACT_LOGISTIC_CONFIG = 'SAVE_NEW_PACT_LOGISTIC_CONFIG';
export const SAVE_NEW_PACT_REQUEST_LOGISTIC_CONFIG = 'SAVE_NEW_PACT_REQUEST_LOGISTIC_CONFIG';
export const SAVE_NEW_PACT_SUCCEEDED_LOGISTIC_CONFIG = 'SAVE_NEW_PACT_SUCCEEDED_LOGISTIC_CONFIG';
export const SAVE_NEW_PACT_FAILED_LOGISTIC_CONFIG = 'SAVE_NEW_PACT_FAILED_LOGISTIC_CONFIG';

export const SAVE_NEW_PACT_LOGISTIC_RULES = 'SAVE_NEW_PACT_LOGISTIC_RULES';
export const SAVE_NEW_PACT_REQUEST_LOGISTIC_RULES = 'SAVE_NEW_PACT_REQUEST_LOGISTIC_RULES';
export const SAVE_NEW_PACT_SUCCEEDED_LOGISTIC_RULES = 'SAVE_NEW_PACT_SUCCEEDED_LOGISTIC_RULES';
export const SAVE_NEW_PACT_FAILED_LOGISTIC_RULES = 'SAVE_NEW_PACT_FAILED_LOGISTIC_RULES';

export const REMOVE_PACT_LOGISTIC_CONFIG = 'REMOVE_PACT_LOGISTIC_CONFIG';
export const REMOVE_PACT_REQUEST_LOGISTIC_CONFIG = 'REMOVE_PACT_REQUEST_LOGISTIC_CONFIG';
export const REMOVE_PACT_SUCCEEDED_LOGISTIC_CONFIG = 'REMOVE_PACT_SUCCEEDED_LOGISTIC_CONFIG';
export const REMOVE_PACT_FAILED_LOGISTIC_CONFIG = 'REMOVE_PACT_FAILED_LOGISTIC_CONFIG';

export const UPDATE_PACT_LOGISTIC_CONFIG = 'UPDATE_PACT_LOGISTIC';
export const UPDATE_PACT_REQUEST_LOGISTIC_CONFIG = 'UPDATE_PACT_REQUEST_LOGISTIC_CONFIG';
export const UPDATE_PACT_SUCCEEDED_LOGISTIC_CONFIG = 'UPDATE_PACT_SUCCEEDED_LOGISTIC_CONFIG';
export const UPDATE_PACT_FAILED_LOGISTIC_CONFIG = 'UPDATE_PACT_FAILED_LOGISTIC_CONFIG';

export const TOGGLE_PACT_STATE_LOGISTIC_CONFIG = 'TOGGLE_PACT_STATE_LOGISTIC_CONFIG';
export const TOGGLE_PACT_STATE_REQUEST_LOGISTIC_CONFIG = 'TOGGLE_PACT_STATE_REQUEST_LOGISTIC_CONFIG';
export const TOGGLE_PACT_STATE_SUCCEEDED_LOGISTIC_CONFIG = 'TOGGLE_PACT_STATE_SUCCEEDED_LOGISTIC_CONFIG';
export const TOGGLE_PACT_STATE_FAILED_LOGISTIC_CONFIG = 'TOGGLE_PACT_STATE_FAILED_LOGISTIC_CONFIG';

export const SAVE_NEW_PACT_DATA_SENSOR_TEMPERATURE = 'SAVE_NEW_PACT_DATA_SENSOR_TEMPERATURE';
export const SAVE_NEW_PACT_REQUEST_DATA_SENSOR_TEMPERATURE = 'SAVE_NEW_PACT_REQUEST_DATA_SENSOR_TEMPERATURE';
export const SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_TEMPERATURE = 'SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_TEMPERATURE';
export const SAVE_NEW_PACT_FAILED_DATA_SENSOR_TEMPERATURE = 'SAVE_NEW_PACT_FAILED_DATA_SENSOR_TEMPERATURE';

export const SAVE_NEW_PACT_DATA_SENSOR_HUMIDITY = 'SAVE_NEW_PACT_DATA_SENSOR_HUMIDITY';
export const SAVE_NEW_PACT_REQUEST_DATA_SENSOR_HUMIDITY = 'SAVE_NEW_PACT_REQUEST_DATA_SENSOR_HUMIDITY';
export const SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_HUMIDITY = 'SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_HUMIDITY';
export const SAVE_NEW_PACT_FAILED_DATA_SENSOR_HUMIDITY = 'SAVE_NEW_PACT_FAILED_DATA_SENSOR_HUMIDITY';

export const SAVE_NEW_PACT_DATA_SENSOR_GASCONTROL = 'SAVE_NEW_PACT_DATA_SENSOR_GASCONTROL';
export const SAVE_NEW_PACT_REQUEST_DATA_SENSOR_GASCONTROL = 'SAVE_NEW_PACT_REQUEST_DATA_SENSOR_GASCONTROL';
export const SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_GASCONTROL = 'SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_GASCONTROL';
export const SAVE_NEW_PACT_FAILED_DATA_SENSOR_GASCONTROL = 'SAVE_NEW_PACT_FAILED_DATA_SENSOR_GASCONTROL';

export const SAVE_NEW_PACT_DATA_SENSOR_GPS = 'SAVE_NEW_PACT_DATA_SENSOR_GPS';
export const SAVE_NEW_PACT_REQUEST_DATA_SENSOR_GPS = 'SAVE_NEW_PACT_REQUEST_DATA_SENSOR_GPS';
export const SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_GPS = 'SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR_GPS';
export const SAVE_NEW_PACT_FAILED_DATA_SENSOR_GPS = 'SAVE_NEW_PACT_FAILED_DATA_SENSOR_GPS';

export const SAVE_NEW_PACT_DATA_SENSOR = 'SAVE_NEW_PACT_DATA_SENSOR';
export const SAVE_NEW_PACT_REQUEST_DATA_SENSOR = 'SAVE_NEW_PACT_REQUEST_DATA_SENSOR';
export const SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR = 'SAVE_NEW_PACT_SUCCEEDED_DATA_SENSOR';
export const SAVE_NEW_PACT_FAILED_DATA_SENSOR = 'SAVE_NEW_PACT_FAILED_DATA_SENSOR';

export const SAVE_NEW_PACT_MAINTENANCE_CONFIG = 'SAVE_NEW_PACT_MAINTENANCE_CONFIG';
export const SAVE_NEW_PACT_REQUEST_MAINTENANCE_CONFIG = 'SAVE_NEW_PACT_REQUEST_MAINTENANCE_CONFIG';
export const SAVE_NEW_PACT_SUCCEEDED_MAINTENANCE_CONFIG = 'SAVE_NEW_PACT_SUCCEEDED_MAINTENANCE_CONFIG';
export const SAVE_NEW_PACT_FAILED_MAINTENANCE_CONFIG = 'SAVE_NEW_PACT_FAILED_MAINTENANCE_CONFIG';

export const SAVE_NEW_PACT_MAINTENANCE_RULES = 'SAVE_NEW_PACT_MAINTENANCE_RULES';
export const SAVE_NEW_PACT_REQUEST_MAINTENANCE_RULES = 'SAVE_NEW_PACT_REQUEST_MAINTENANCE_RULES';
export const SAVE_NEW_PACT_SUCCEEDED_MAINTENANCE_RULES = 'SAVE_NEW_PACT_SUCCEEDED_MAINTENANCE_RULES';
export const SAVE_NEW_PACT_FAILED_MAINTENANCE_RULES = 'SAVE_NEW_PACT_FAILED_MAINTENANCE_RULES';

export const SAVE_NEW_PACT_PROFORMA_CONFIG = 'SAVE_NEW_PACT_PROFORMA_CONFIG';
export const SAVE_NEW_PACT_REQUEST_PROFORMA_CONFIG = 'SAVE_NEW_PACT_REQUEST_PROFORMA_CONFIG';
export const SAVE_NEW_PACT_SUCCEEDED_PROFORMA_CONFIG = 'SAVE_NEW_PACT_SUCCEEDED_PROFORMA_CONFIG';
export const SAVE_NEW_PACT_FAILED_PROFORMA_CONFIG = 'SAVE_NEW_PACT_FAILED_PROFORMA_CONFIG';

export const SAVE_NEW_PACT_PROFORMA_RULES = 'SAVE_NEW_PACT_PROFORMA_RULES';
export const SAVE_NEW_PACT_REQUEST_PROFORMA_RULES = 'SAVE_NEW_PACT_REQUEST_PROFORMA_RULES';
export const SAVE_NEW_PACT_SUCCEEDED_PROFORMA_RULES = 'SAVE_NEW_PACT_SUCCEEDED_PROFORMA_RULES';
export const SAVE_NEW_PACT_FAILED_PROFORMA_RULES = 'SAVE_NEW_PACT_FAILED_PROFORMA_RULES';

//------------------------------
//Models Radiks
//------------------------------
export const SAVE_MODEL = 'SAVE_MODEL';
export const SAVING_MODEL = 'SAVING_MODEL';
export const SAVED_MODEL = 'SAVED_MODEL';
export const FETCHING_MODELS = 'FETCHING_MODELS';
export const FETCHED_MODELS = 'FETCHED_MODELS';
export const FETCHING_MODEL = 'FETCHING_MODEL';
export const FETCHED_MODEL = 'FETCHED_MODEL';
export const SELECT_MODEL = 'SELECT_MODEL';
export const DESELECT_MODEL = 'DESELECT_MODEL';
export const FETCHING_USER_GROUPS = 'FETCHING_USER_GROUPS';
export const FETCHED_USER_GROUPS = 'FETCHED_USER_GROUPS';
export const FETCHING_USER_GROUP = 'FETCHING_USER_GROUP';
export const FETCHED_USER_GROUP = 'FETCHED_USER_GROUP';

//------------------------------
//Template
//------------------------------
export const MOSTRAR_TEMPLATEALL = 'MOSTRAR_TEMPLATEALL';
export const MOSTRAR_TEMPLATE = 'MOSTRAR_TEMPLATE';
export const TOKEN_TEMPLATE = 'TOKEN_TEMPLATE';
